export const COMPANY_FORM_FIELDS = [
  { label: 'Company Name', field: 'name', required: true },
  { label: 'Description', field: 'description', required: true },
  { label: 'Admin User Email', field: 'email', required: true },
  { label: 'Phone', field: 'phone', required: false },
  { label: 'Website', field: 'website', required: false },
  { label: 'Address Line 1', field: 'address1', required: true },
  { label: 'Address Line 2', field: 'address2', required: false },
  { label: 'City', field: 'city', required: true },
  { label: 'State/Province', field: 'state', required: true },
  { label: 'Postal Code', field: 'postalCode', required: true },
];

// Mirrors the backend `OrganizationTypeEnum` — values must match exactly.
export const COMPANY_TYPE = [
  { label: 'General', value: 'general' },
  { label: 'Enterprise', value: 'enterprise' },
];

export const ENTERPRISE_COMPANY_TYPE = 'enterprise';
export const GENERAL_COMPANY_TYPE = 'general';

export const COMPANY_FORM_INITIAL_STATE = {
  name: '',
  description: '',
  industry: '',
  contract_types: [],
  email: '',
  phone: '',
  website: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  postalCode: '',
  country: 'United Kingdom',
  companyType: '',
  // Enterprise infrastructure (only submitted when companyType === 'enterprise')
  subdomain: '',
  slug: '',
  // Backend-managed provisioning flags (read-only on the UI, always default to false)
  isDbCreated: false,
  isCognitoPoolCreated: false,
  isSqsReady: false,
  isServiceReady: false,
  // Lifecycle flags — a newly created organization is always active.
  is_active: true,
  is_deleted: false,
};
